(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payment/assets/javascripts/services/analytics.js') >= 0) return;  svs.modules.push('/components/tur/payment/assets/javascripts/services/analytics.js');
'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class Analytics {
  constructor(_ref) {
    let _ref$wagerId = _ref.wagerId,
      wagerId = _ref$wagerId === void 0 ? 0 : _ref$wagerId,
      betsObj = _ref.betsObj,
      wagerModel = _ref.wagerModel;
    this.betsObj = betsObj;
    this.wagerId = wagerId;
    this.wagerModel = wagerModel;
    this.productName = svs.numbergames.productMapping.getProductName(this.wagerModel.get('productId'));
    const transaction = this.createTransaction();
    let gameType = 'enkelrader';
    if (wagerModel.get('prolongedBet')) {
      gameType = 'förlängspel';
    } else if (wagerModel.get('isPackage')) {
      gameType = 'färdigaspel';
    } else if (wagerModel.get('isSystem')) {
      gameType = 'systemspel';
    }
    const options = {
      gameType,
      gameAccount: 'mitt saldo'
    };
    svs.components.analytics.trackTransaction(transaction, options);
  }
  createTransaction() {
    const trackingBets = this.getTrackingBets();
    const items = [];
    trackingBets.forEach(bet => {
      const productId = bet.productId,
        productName = bet.productName,
        price = bet.price,
        quantity = bet.quantity,
        extraData = bet.extraData;
      const trackingItem = new svs.components.analytics.transactionItem(productId, productName, price, quantity, extraData);
      items.push(trackingItem);
    });
    return new svs.components.analytics.transaction(this.wagerId, this.wagerModel.get('price'), items, 0, 0, undefined, this.productName);
  }
  getTrackingBets() {
    const CurrencyFromJupiterString = svs.utils.format.CurrencyFromJupiterString;
    const trackingBets = [];
    this.betsObj.forEach(bet => {
      const trackingBet = {
        productName: this.productName,
        price: CurrencyFromJupiterString(bet.betAmountSalesGroup1),
        productId: bet.productId,
        quantity: 1,
        extraData: this.createExtraData()
      };
      switch (bet.productId) {
        case 'LORLOTTO':
        case 'ONSLOTTO':
          trackingBet.productName = "Lotto 1 ".concat(/^LOR/.test(bet.productId) ? 'Lördag' : 'Onsdag');
          trackingBets.push(trackingBet);
          if (CurrencyFromJupiterString(bet.betAmountSalesGroup2) > 0) {
            trackingBets.push(_objectSpread(_objectSpread({}, trackingBet), {}, {
              productName: trackingBet.productName.replace('1', '2'),
              productId: "".concat(trackingBet.productId, "2")
            }));
          }
          break;
        case 'ONSJOKER':
        case 'LORJOKER':
          trackingBet.productName = "Joker ".concat(/^LOR/.test(bet.productId) ? 'Lördag' : 'Onsdag');
          trackingBet.extraData = null;
          trackingBets.push(trackingBet);
          break;
        case 'KENO':
          {
            trackingBet.price = CurrencyFromJupiterString(bet.betAmountSalesGroup1) + CurrencyFromJupiterString(bet.betAmountSalesGroup2);
            trackingBets.push(trackingBet);
            break;
          }
        case 'ELOTTO':
        case 'TELOTTO':
          trackingBet.productName = svs.numbergames.productMapping.getProductDayName(bet.productId);
          trackingBets.push(trackingBet);
          break;
        default:
          trackingBets.push(trackingBet);
      }
    });
    return trackingBets;
  }

  createExtraData() {
    const extraData = {
      quickPick: this.wagerModel.getQuickpickState(),
      rounds: parseInt(this.wagerModel.get('drawCount'), 10)
    };
    if (this.wagerModel.get('isPackage')) {
      extraData.bag = "".concat(this.wagerModel.get('selectedPackage'), ":").concat(this.wagerModel.get('productId').toLowerCase(), " ").concat(this.wagerModel.get('price'));
    }
    if (this.wagerModel.get('isSystem')) {
      const b = this.wagerModel.get('boards').first();
      extraData.system = "".concat(b.get('numbers').length).concat(this.wagerModel.has('numbersExtra') ? ",".concat(b.get('numbersExtra').length) : '');
    }
    if (this.wagerModel.get('prolongedBet')) {
      extraData.prolong = '1';
    }
    if (this.wagerModel.get('boards').getValidBoards().some(b => b.get('hasKungKeno'))) {
      extraData.kungkeno = true;
    }
    return extraData;
  }
}
svs.tur.payment.services.Analytics = Analytics;

 })(window);